<template>
  <div class="cont">
    <div class="title">
      <img src="@/assets/dapingImg/logo.png" style="width:10%;flex-grow:0">
      <div>
        <p class="shijian">{{nowTime}}</p>
        <p class="riqi">{{nowDate}}</p>
      </div>
    </div>
    <div class="zhutiBox">
      <div class="bian">
        <div class="bian1 box1">
          <div class="title1">
            <div class="biaoti">车队当日作业</div>
          </div>
          <div style="height:calc(100% - 40px);" id="ysrwzlId">
            <div style="display: flex;justify-content: space-around;">
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.dispatchWeight}}</p><p class="lyTitle">待装车<span style="font-size: 12px;">（吨）</span></p></div>
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.loadingWeight}}</p><p class="lyTitle">运输中<span style="font-size: 12px;">（吨）</span></p></div>
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.unloadingWeight}}</p><p class="lyTitle">已卸车<span style="font-size: 12px;">（吨）</span></p></div>
            </div>
            <div style="display: flex;justify-content: space-around;">
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.dispatchWayCount}}</p><p class="lyTitle">待装车<span style="font-size: 12px;">（趟）</span></p></div>
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.loadingWayCount}}</p><p class="lyTitle">运输中<span style="font-size: 12px;">（趟）</span></p></div>
              <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.signingWayCount}}</p><p class="lyTitle">已卸车<span style="font-size: 12px;">（趟）</span></p></div>
            </div>
          </div>
        </div>
        <div class="bian1 box1 vehicle-distribution-card">
          <div class="title1">
            <div class="biaoti">车辆分布情况</div>
          </div>
          <div style="height:calc(100% - 40px);" id="yyfysId">
          </div>
        </div>
        <div class="bian2 box1">
          <div class="title1">
            <div class="biaoti">证件异常提醒</div>
            <!-- <div class="tab">
              <span :class="{active:dqIndex4==3}" @click="qiehuan4(3)">本周</span>
              <span :class="{active:dqIndex4==2}" @click="qiehuan4(2)">今日</span>
              <span :class="{active:dqIndex4==4}" @click="qiehuan4(4)">本月</span>
              <span :class="{active:dqIndex4==1}" @click="qiehuan4(1)">累计</span>
            </div> -->
          </div>
          <div style="height:calc(100% - 48px);margin-top:8px" class="topCon_body table-wrapper" >
            <div id="table">
              <div class="tables xmrwBox">
                <span class="span_one" style="width: 15%;">序号</span>
                <span class="span_one" style="width: 35%;">证件类型</span>
                <span class="span_one" >待过期</span>
                <span class="span_one" style="color:#ff0000;font-weight: 600;">已过期</span>
              </div>
              <vue-seamless-scroll :data="zhengJianList" :class-option="optionSettingXM" class="seamless-warp2" >
                <ul class="item xmrwBox">
                  <li v-for="(item,index) in zhengJianList" :key="index">
                    <span style="width: 15%;">{{ index+1 }}</span>
                    <span v-text="item.certType" style="width: 35%;"></span>
                    <span v-text="item.pendingCount"></span>
                    <span v-text="item.expiredCount" style="color:#ff0000;font-weight: 600;"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="center1 box1">
          <div class="title1">
            <div class="biaoti">自有运力统计</div>
          </div>
          <div style="height:calc(100% - 40px);position: relative;" >
            <div id="map" style="width:100%;height:100%"></div>
            <div class="dituTuli">
              <div class="yunli-row">
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.totalVehicle}}</p>
                  <p class="lyTitle">自有车数<span>（辆）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.totalDriver}}</p>
                  <p class="lyTitle">自有司机<span>（人）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.totalSigningWeight}}</p>
                  <p class="lyTitle">总拉运量<span>（吨）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.totalWayCount}}</p>
                  <p class="lyTitle">总拉单数<span>（个）</span></p>
                </div>
              </div>
              <div class="yunli-row">
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.idleVehicle}}</p>
                  <p class="lyTitle">空闲中<span>（辆）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.workingVehicle}}</p>
                  <p class="lyTitle">作业中<span>（辆）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.maintainingVehicle}}</p>
                  <p class="lyTitle">维修中<span>（辆）</span></p>
                </div>
                <div class="yunli-item">
                  <p class="lyCunt">{{yunLiData.chargingVehicle}}</p>
                  <p class="lyTitle">充电中<span>（辆）</span></p>
                </div>
              </div>
            </div>
            <div class="energy-vehicle-box">
              <div class="energy-vehicle-item">
                <span class="energy-vehicle-name">油车</span>
                <span class="energy-vehicle-count">{{nengYuanData.oilCount}}</span>
                <span class="energy-vehicle-unit">辆</span>
              </div>
              <div class="energy-vehicle-item">
                <span class="energy-vehicle-name">气车</span>
                <span class="energy-vehicle-count">{{nengYuanData.gasCount}}</span>
                <span class="energy-vehicle-unit">辆</span>
              </div>
              <div class="energy-vehicle-item">
                <span class="energy-vehicle-name">电车</span>
                <span class="energy-vehicle-count">{{nengYuanData.electricCount}}</span>
                <span class="energy-vehicle-unit">辆</span>
              </div>
            </div>
            <div class="team-vehicle-box">
              <div class="team-vehicle-item" v-for="(item,index) in teamData" :key="index">
                <span class="team-vehicle-name">{{item.teamName}}</span>
                <span class="team-vehicle-count">{{item.vehicleNum}}</span>
                <span class="team-vehicle-unit">辆</span>
              </div>
            </div>
          </div>
        </div>
        <div class="center2 box1">
          <div class="title1">
            <div class="biaoti">实时拉运情况(万吨)</div>
            <div class="tab">
              <span :class="{active:lyIndex=='month'}" @click="laYunQiehuan('month')">按月</span>
              <span :class="{active:lyIndex=='day'}" @click="laYunQiehuan('day')">按天</span>
            </div>
          </div>
          <div style="height:calc(100% - 50px)" id="ndzsId"></div>
        </div>
      </div>
      <div class="bian">
        <div class="bian1 box1">
          <div class="title1">
            <div class="biaoti">常走流向情况</div>
          </div>
          <div style="height:calc(100% - 48px);margin-top:8px" class="topCon_body table-wrapper" >
            <div id="table">
              <div class="tables xmrwBox">
                <span class="span_one" style="width: 15%;">序号</span>
                <span class="span_one" style="width: 35%;">常走流向</span>
                <span class="span_one">拉运量(吨)</span>
                <span class="span_one">拉运单数</span>
              </div>
              <vue-seamless-scroll :data="liuXiangList" :class-option="optionSettingLX" class="seamless-warp2" >
                <ul class="item xmrwBox">
                  <li v-for="(item,index) in liuXiangList" :key="index">
                    <span style="width: 15%;">{{ index+1 }}</span>
                    <span v-text="item.flowName" style="width: 35%;"></span>
                    <span v-text="item.totalWeight"></span>
                    <span v-text="item.orderCount"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
        <div class="bian1 box1">
          <div class="title1">
            <div class="biaoti">能源消耗排行</div>
          </div>
          <div style="height:calc(100% - 48px);margin-top:8px" class="topCon_body table-wrapper" >
            <div id="table">
              <div class="tables xmrwBox">
                <span class="span_one" >序号</span>
                <span class="span_one" >能源类型</span>
                <span class="span_one">车牌号</span>
                <span class="span_one">消耗金额(元)</span>
              </div>
              <vue-seamless-scroll :data="nengYuanList" :class-option="optionSettingNY" class="seamless-warp2" >
                <ul class="item xmrwBox">
                  <li v-for="(item,index) in nengYuanList" :key="index">
                    <span >{{ index+1 }}</span>
                    <span v-text="item.energyType" ></span>
                    <span v-text="item.plateNumber"></span>
                    <span v-text="item.totalCost"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
        <div class="bian2 box1">
          <div class="title1">
            <div class="biaoti">车辆年检到期提醒</div>
          </div>
          <div style="height:calc(100% - 48px);margin-top:8px" class="topCon_body table-wrapper" >
            <div id="table">
              <div class="tables xmrwBox">
                <span class="span_one" >序号</span>
                <span class="span_one" >车牌号</span>
                <span class="span_one">所属小队</span>
                <span class="span_one">距年检到期天数(天)</span>
              </div>
              <vue-seamless-scroll :data="nianJianList" :class-option="optionSettingNY" class="seamless-warp2" >
                <ul class="item xmrwBox">
                  <li v-for="(item,index) in nianJianList" :key="index">
                    <span >{{ index+1 }}</span>
                    <span v-text="item.plateNumber" ></span>
                    <span v-text="item.teamName"></span>
                    <span v-text="item.remainingDays"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
     <el-dialog  title="异常报警" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="baojingFlag" width="1000px" center>
      <div>
        <el-table height="400px" size="mini" ref="tabref" :data="baojingList" style="width:100%"  border center>
          <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
          <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="lookImage(scope.row)">查看图片</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="wayNo" width="230" label="运单号"></el-table-column>
          <el-table-column prop="exceptionType" width="120" :formatter="emptyFn" label="异常类型">
            <template scope="scope">
              <span v-show="scope.row.exceptionType == '1'">堵车</span>
              <span v-show="scope.row.exceptionType == '2'">车辆故障</span>
              <span v-show="scope.row.exceptionType == '3'">天气异常</span>
              <span v-show="scope.row.exceptionType == '4'">交通事故</span>
              <span v-show="scope.row.exceptionType == '5'">其他</span>
            </template>
          </el-table-column>
          <el-table-column prop="exceptionDescribe" width="230" :formatter="emptyFn" label="异常信息" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="exceptionType" width="120" :formatter="emptyFn" label="解决状态">
            <template scope="scope">
              <span v-show="scope.row.status == '0'">未解决</span>
              <span v-show="scope.row.status == '1'">已解决</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="address" width="" :formatter="emptyFn" label="上报位置" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="baojingFlag = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="50%" center>
      <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
      <div class="img_box" v-for="(item,index) in imgList" :key="index">
        <el-image :src="item" :preview-src-list="getSrcList(index)" class="tupian" ></el-image>
      </div>
    </el-dialog>
    <el-dialog title="行驶信息" :close-on-click-modal="false" :visible.sync="xingshiFlag" width="500px" center>
      <div>
        <h4>{{vehGps.plain}}<span style="margin-left:50px">{{vehGps.driverName}} | {{vehGps.teamOrgName}} | {{vehGps.operationOrgName}}</span></h4>
        <div class="boxXS">
          <div class="item"><span  class="name">行驶状态：</span><span>{{vehGps.status}}</span></div>
          <div class="item"><span  class="name">总里程：</span><span>{{vehGps.mileage}}</span></div>
          <div class="item"><span  class="name">当前速度：</span><span>{{vehGps.speed}}KM/H</span></div>
          <div class="item"><span  class="name">当前方向：</span><span> {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][vehGps.fx-1]}}</span></div>
          <div class="item"><span  class="name">设备ID：</span><span>{{vehGps.terminal_code}}</span></div>
          <div class="item"><span  class="name">SIM卡号：</span><span>{{vehGps.sim}}</span></div>
          <div class="item"><span  class="name">经度：</span><span>{{vehGps.longitude}}</span></div>
          <div class="item"><span  class="name">纬度：</span><span>{{vehGps.latitude}}</span></div>
          <div class="item"><span  class="name">运单号：</span><span>{{vehGps.wayNo}}</span></div>
          <div class="item"><span  class="name">货物：</span><span>{{vehGps.productTypeName}}</span></div>
          <div class="item item1"><span  class="name">线路：</span><span>{{vehGps.lineName}}</span></div>
          <div class="item item1"><span  class="name">当前位置：</span><span>{{vehGps.address}}</span></div>
          <div class="item item1"><span  class="name">上报时间：</span><span>{{vehGps.gps_time}}</span></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xingshiFlag = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { realTimeWay, driverOrVehicleTrafficRank, exceptionGetImage, vehiclePositionList, customerPositionList, vehiclePositionInfo, getWayForVehicle } from '@/api/newTMS'
import { findTodayOperation, findVhcEnergyStat, findVhcDistribution, findCertificate, findSigningTrendStat, findTopFlowStat, findVehicleEnergyRank, findOwnFleetStat, findVehicleMapLocation, findVehicleInspectionStat } from '@/api/data-center-server'
import { teamVehicleStatistics } from '@/api/vgs-driver2.0'
// import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import { emptyFn, toFixed } from '@/utils/util'
// import letingxian from '@/views/daping/letingxian.json'
import AMap from 'AMap'
import goodCarIcon from '@/assets/images/goodCar.png'
export default {
  components: {
  },
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      emptyFn: emptyFn,
      dqIndex1: 3, // 运输任务总览
      dqIndex2: 3, // 人车运量排行
      dqIndex3: 2, // 项目运量走势
      dqIndex4: 3, // 项目任务占比
      dqIndex5: 3, // 运营方运输排行
      dqIndex6: 3, // 减碳情况
      businessType: 0, // 人车运量排行
      lyIndex: 'month',
      yunshuList: [],
      rencheList: [],
      generalCode: '', // 承运商code
      CYSList: [],
      baojingFlag: false, // 异常报警
      baojingList: [],
      ssrow: {},
      imgData: [],
      imgList: [],
      dwList: [],
      addMarkLookBox: false,
      mapDate: [],
      zuobiaoFlag: 1,
      zuobiaoCont: '',
      xingshiFlag: false,
      vehGps: {},
      xmList: [],
      sousuoMarker: null,
      map: null,
      timer: null,
      carList: [],
      vehicleMarkers: [],
      tenantCode: localStorage.getItem('tenantCode'),
      drlyShuju: {},
      vhcFenBu: [],
      zhengJianList: [],
      liuXiangList: [],
      nengYuanList: [],
      yunLiData: {},
      nianJianList: [],
      nengYuanData: {},
      teamData: []
    }
  },
  created () {
    this.getDate()
    this.nowTimer = setInterval(this.getDate, 500)
    let that = this
    this.findTodayOperation()// 当日作业
    this.findVhcDistribution()// 车辆分布饼图
    this.findCertificate()// 证件异常提醒
    this.findSigningTrendStat()// 实时拉运情况
    this.findTopFlowStat()// 常走流向情况
    this.findVehicleEnergyRank()// 能源消耗排行
    this.findOwnFleetStat()// 自有运力
    this.findVehicleInspectionStat()// 车辆年检
    this.findVhcEnergyStat()// 自家能源类型统计
    this.teamVehicleStatistics()// 获取车辆小队小组
    this.timer = setInterval(function () {
      this.findTodayOperation()// 当日作业
      this.findOwnFleetStat()// 自有运力
      this.findSigningTrendStat()// 实时拉运情况
    }, 60000 * 5)
  },
  mounted () {
    this.initMapgd()
    this.findVehicleMapLocation()
  },
  destroyed () {
    clearInterval(this.timer)
    clearInterval(this.nowTimer)
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    // 当日作业
    findTodayOperation () {
      findTodayOperation().then(res => {
        this.drlyShuju = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 车辆分布饼图
    findVhcDistribution () {
      findVhcDistribution().then(res => {
        this.vhcFenBu = res
        const chartData = (res || []).map(item => {
          return {
            name: item.name,
            value: Number(item.count || 0)
          }
        }).filter(item => item.name)
        this.$nextTick(() => {
          this.vhcDistributionChart(chartData)
        })
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 证件异常提醒
    findCertificate () {
      findCertificate().then(res => {
        this.zhengJianList = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    laYunQiehuan (n) {
      this.lyIndex = n
      this.findSigningTrendStat()
    },
    // 实时拉运情况
    findSigningTrendStat () {
      findSigningTrendStat({ statType: this.lyIndex }).then(res => {
        let data = []
        let name = []
        res.forEach(item => {
          data.push(item.value)
          name.push(item.label)
        })
        this.xian(data, name, 'ndzsId')
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 常走流向情况
    findTopFlowStat () {
      findTopFlowStat().then(res => {
        this.liuXiangList = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 能源消耗排行
    findVehicleEnergyRank () {
      findVehicleEnergyRank().then(res => {
        this.nengYuanList = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 自有运力
    findOwnFleetStat () {
      findOwnFleetStat().then(res => {
        this.yunLiData = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 自家能源类型统计
    findVhcEnergyStat () {
      findVhcEnergyStat().then(res => {
        this.nengYuanData = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 获取车辆小队小组
    teamVehicleStatistics (flag) {
      teamVehicleStatistics({ }).then((res) => {
        this.teamData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 地图
    findVehicleMapLocation () {
      findVehicleMapLocation().then(res => {
        this.carList = this.formatVehicleMapPoints(Array.isArray(res) ? res : (res && res.data) ? res.data : [])
        this.renderVehicleMarkers(this.carList)
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    formatVehicleMapPoints (list) {
      return (list || []).reduce((points, item) => {
        if (item.longitude === null || item.longitude === undefined || item.longitude === '' ||
          item.latitude === null || item.latitude === undefined || item.latitude === '') {
          return points
        }
        const longitude = Number(item.longitude)
        const latitude = Number(item.latitude)
        if (!Number.isFinite(longitude) || !Number.isFinite(latitude) || longitude === 0 || latitude === 0) {
          return points
        }
        points.push({
          longitude,
          latitude,
          plateNumber: item.plateNumber || '',
          lnglat: [longitude, latitude],
          name: item.plateNumber || ''
        })
        return points
      }, [])
    },
    escapeMarkerText (text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    renderVehicleMarkers (points) {
      const map = this.initMapgd()
      if (!map) {
        return
      }
      if (this.vehicleMarkers.length) {
        this.vehicleMarkers.forEach(marker => {
          marker.setMap(null)
        })
        this.vehicleMarkers = []
      }
      if (!points.length) {
        map.setZoomAndCenter(4.8, [104.06, 35.67])
        return
      }
      const icon = new AMap.Icon({
        image: goodCarIcon,
        size: new AMap.Size(36, 36),
        imageSize: new AMap.Size(36, 36)
      })
      points.forEach(item => {
        const marker = new AMap.Marker({
          position: new AMap.LngLat(item.longitude, item.latitude),
          icon: icon,
          offset: new AMap.Pixel(-18, -18),
          title: item.plateNumber,
          draggable: false,
          bubble: false,
          cursor: 'pointer'
        })
        marker.setMap(map)
        this.vehicleMarkers.push(marker)
      })
      if (points.length === 1) {
        map.setZoomAndCenter(12, [points[0].longitude, points[0].latitude])
        return
      }
      map.setFitView(this.vehicleMarkers, false, [80, 80, 80, 80])
    },
    // 车辆年检
    findVehicleInspectionStat () {
      findVehicleInspectionStat().then(res => {
        this.nianJianList = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    xian (rawValues, months, id) {
      let _this = this
      var numData = rawValues.map(Number)
      var chart = _this.$echarts.init(document.getElementById(id))

      // 计算合理的 Y 轴最小值（不小于 0，且留一点余量）
      var dataMin = Math.min.apply(null, numData)
      var dataMax = Math.max.apply(null, numData)
      var yMin = Math.max(0, Math.floor(dataMin * 0.9))
      var yMax = Math.ceil(dataMax * 1.05)
      // 如果数据范围太小（< 50），适当扩展 Y 轴范围
      if (yMax - yMin < 50) {
        var mid = (yMin + yMax) / 2
        yMin = Math.max(0, Math.floor(mid - 25))
        yMax = Math.ceil(mid + 25)
      }

      chart.setOption({
        legend: { show: false },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(10,26,47,0.95)',
          borderColor: '#00e5ff',
          borderWidth: 1,
          padding: [10, 14],
          textStyle: { color: '#fff', fontSize: 14 },
          formatter: function (params) {
            var p = params[0]
            return '<b style="color:#8ab4d6">' + p.name + '</b><br/>' +
               '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;' +
               'background:#00e5ff;margin-right:8px;box-shadow:0 0 6px #00e5ff"></span>' +
               '<b style="color:#00e5ff;font-size:16px">' + p.value + '</b>'
          }
        },

        grid: {
          left: 80,
          top: 45,
          right: 55,
          bottom: 75
        },

        xAxis: {
          type: 'category',
          data: months,
          boundaryGap: false,

          axisLine: {
            show: true,
            lineStyle: { color: '#1a3a5c', width: 1 }
          },
          axisTick: { show: false },
          axisLabel: {
            interval: 0,
            rotate: 38,
            color: '#8ab4d6',
            fontSize: 12,
            margin: 18
          }
        },

        yAxis: {
          type: 'value',
          min: yMin,
          max: yMax,

          axisLine: { show: false },
          axisTick: { show: false },

          splitLine: {
            lineStyle: {
              color: '#162d4a',
              type: 'dashed'
            }
          },

          axisLabel: {
            color: '#8ab4d6',
            fontSize: 13,
            formatter: function (v) {
              // if (v >= 10000) return (v / 10000).toFixed(1) + 'w'
              // if (v >= 1000) return (v / 1000).toFixed(1) + 'k'
              return (v / 10000).toFixed(1)
            }
          }
        },

        series: [{
          name: '实时拉运',
          type: 'line',
          smooth: 0.3,
          symbol: 'circle',
          symbolSize: 8,
          data: numData,

          lineStyle: {
            color: '#00e5ff',
            width: 2.5,
            shadowColor: 'rgba(0,229,255,0.5)',
            shadowBlur: 8,
            shadowOffsetY: 2
          },

          itemStyle: {
            color: '#0a1a2f',
            borderWidth: 2.5,
            borderColor: '#00e5ff',
            shadowColor: 'rgba(0,229,255,0.7)',
            shadowBlur: 8
          },

          areaStyle: {
            color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,229,255,0.32)' },
              { offset: 1, color: 'rgba(0,229,255,0)' }
            ])
          },

          // ★ 每个数据点上方标注数值
          label: {
            show: true,
            position: 'top',
            distance: 10,
            color: '#e0f0ff',
            fontSize: 12,
            fontWeight: 'bold',
            formatter: function (p) {
              var v = p.value
              // if (v >= 1000) return (v / 1000).toFixed(1) + 'k'
              return (v / 1000).toFixed(1)
            }
          },

          emphasis: {
            focus: 'series',
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 3,
              shadowBlur: 16,
              shadowColor: 'rgba(0,229,255,0.9)'
            },
            label: {
              fontSize: 15,
              color: '#fff',
              fontWeight: 'bold'
            }
          }
        }]
      })
    },
    vhcDistributionChart (data) {
      const chartDom = document.getElementById('yyfysId')
      if (!chartDom) return
      const myChart = this.$echarts.getInstanceByDom(chartDom) || this.$echarts.init(chartDom)
      const colorList = ['#00E5FF', '#3B82F6', '#5BD942', '#FFD166', '#FF8A3D', '#FF5B5B', '#9B6BFF']

      myChart.setOption({
        color: colorList,
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.marker + params.name + '：' + params.value + ' 辆（' + params.percent + '%）'
          }
        },
        legend: {
          orient: 'vertical',
          right: '7%',
          top: 'middle',
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function (name) {
            const current = data.find(item => item.name === name)
            return name + '  ' + (current ? current.value : 0)
          }
        },
        graphic: !data.length ? {
          type: 'text',
          left: 'center',
          top: 'middle',
          style: {
            text: '暂无数据',
            fill: '#fff',
            fontSize: 14
          }
        } : null,
        series: [
          {
            name: '车辆分布',
            type: 'pie',
            radius: ['40%', '62%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: true,
            minAngle: 5,
            label: {
              show: true,
              color: '#fff',
              formatter: '{b} {d}%'
            },
            labelLine: {
              show: true,
              length: 12,
              length2: 10,
              lineStyle: {
                color: 'rgba(255,255,255,0.6)'
              }
            },
            itemStyle: {
              borderColor: '#072648',
              borderWidth: 4
            },
            emphasis: {
              scale: true,
              scaleSize: 6
            },
            data: data
          }
        ]
      }, true)
    },
    getDate: function () {
      var _this = this
      const dat = new Date()
      const year = dat.getFullYear()
      const month = (dat.getMonth() + 1).toString().padStart(2, 0)
      const day = (dat.getDate()).toString().padStart(2, 0)
      const hours = (dat.getHours()).toString().padStart(2, 0)
      const minutes = (dat.getMinutes()).toString().padStart(2, 0)
      const second = (dat.getSeconds()).toString().padStart(2, 0)
      _this.nowTime = hours + ':' + minutes + ':' + second
      _this.nowDate = year + '/' + month + '/' + day
    },
    // 地图上的查询
    zuobianFn () {
      let that = this
      if (this.sousuoMarker) {
        this.map.remove(this.sousuoMarker)
      }

      this.dwList = []
      if (this.zuobiaoFlag == 1) {
        vehiclePositionList({ vhcNo: this.zuobiaoCont }).then(res => {
          if (res.vehicleList.length == 1) {
            this.highlightTargetPoint(this.carList.concat(this.mapDate), [res.vehicleList[0].longitude, res.vehicleList[0].latitude])
            this.map.setZoomAndCenter(18, [res.vehicleList[0].longitude, res.vehicleList[0].latitude])
          }
        }).catch(error => {
          this.$message.error(error.message)
        })
      } else if (this.zuobiaoFlag == 6) { // 高德地图位置搜索
        AMap.plugin('AMap.PlaceSearch', function () {
          var autoOptions = {
            city: '全国'
          }
          var placeSearch = new AMap.PlaceSearch(autoOptions)
          placeSearch.search(that.zuobiaoCont, function (status, result) {
            console.log(result.poiList.pois[0])
            that.sousuoMarker = new AMap.Marker({
              position: result.poiList.pois[0].location,
              icon: new AMap.Icon({
                image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/img/daheshiji/dingwei.png',
                size: new AMap.Size(40, 40),
                imageSize: new AMap.Size(40, 40)
              }),
              offset: new AMap.Pixel(0, 0),
              map: that.map
            })
            that.map.setZoomAndCenter(18, result.poiList.pois[0].location)
            // 创建信息窗体对象
            var infoWindow = new AMap.InfoWindow({
              offset: new AMap.Pixel(0, 0),
              showCloseButton: false
            })
            that.sousuoMarker.content = `<div style="color: #fff;font-size: 16px;padding: 16px;
                      background: linear-gradient(180deg, rgba(37,108,233,0.44) 0%, rgba(23,80,169,0.1) 22%, rgba(20,64,137,0) 46%, rgba(16,51,111,0.28) 77%, rgba(30,101,213,0.4) 100%);
                      border-radius: 2px;border: 1px solid;border-image: radial-gradient(circle, rgba(111, 185, 242, 0.86), rgba(0, 0, 0, 0.2)) 1 1;
                      backdrop-filter: blur(10px);">
                        <div>
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;"></span>
                            <span>${result.poiList.pois[0].name}</span>
                          </div>
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;">地址：</span>
                            <span>${result.poiList.pois[0].address}</span>
                          </div>
                        </div>
                      </div>`
            // 绑定鼠标移入事件
            that.sousuoMarker.on('mouseover', function (e) {
              infoWindow.setContent(e.target.content)
              infoWindow.open(that.map, e.target.getPosition())
            })
            // 绑定鼠标移出事件
            that.sousuoMarker.on('mouseout', function (e) {
              infoWindow.close()
            })
          })
        })
      } else {
        customerPositionList({ customerName: this.zuobiaoCont }).then(res => {
          if (res.length == 1) {
            this.highlightTargetPoint(this.carList.concat(this.mapDate), [res[0].longitude, res[0].latitude])
            this.map.setZoomAndCenter(15, [res[0].longitude, res[0].latitude])
          }
        }).catch(error => {
          this.$message.error(error.message)
        })
      }
    },
    // 突出显示目标点
    highlightTargetPoint (markers, targetPosition) {
      for (var i = 0; i < markers.length; i++) {
        var marker = markers[i]
        var markerPos = marker.w.weizhi
        console.log(markerPos)
        console.log(targetPosition[0])
        if (markerPos[0] == targetPosition[0] && markerPos[1] == targetPosition[1]) {
          // 可以进一步设置其他样式，如大小、透明度等
          marker.setIcon(new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/img/daheshiji/dingwei1.gif',
            size: new AMap.Size(60, 60),
            imageSize: new AMap.Size(60, 60)
          }))
        } else {
          // 恢复其他标记点的默认样式
          marker.setIcon(new AMap.Icon({
            image: marker.w.icon.w.image,
            size: new AMap.Size(40, 40),
            imageSize: new AMap.Size(40, 40)
          }))
        }
      }
    },
    lookImage (row) {
      this.addMarkLookBox = true
      exceptionGetImage({
        id: row.id
      }).then(res => {
        this.imgList = []
        this.imgData = res
        this.imgList = res.map(item => item.fileKeyUrl)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 点击图片放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 点击车辆点
    showInfoM (e) {
      let that = this
      console.log(e.target.w.id)
      vehiclePositionInfo({ id: e.target.w.id }).then(res => {
        that.vehGps = res
        getWayForVehicle({ vehicleId: e.target.w.id }).then(res => {
          that.vehGps.wayNo = res.wayNo
          that.vehGps.productTypeName = res.productTypeName
          that.vehGps.lineName = res.lineName
        }).catch(error => {
          that.$message.error(error.message)
        })
      }).catch(error => {
        that.$message.error(error.message)
      })

      that.xingshiFlag = true
    },
    // 地图
    async dituFn () {
      await this.findVehicleMapLocation()
    },
    initMapgd () {
      if (this.map) {
        return this.map
      }
      const mapDom = document.getElementById('map')
      if (!mapDom) {
        return null
      }
      this.map = new AMap.Map('map', {
        zoom: 4.1,
        center: [108.94, 34.34],
        mapStyle: 'amap://styles/darkblue',
        zooms: [4, 18]
      })
      return this.map
    },
    initmap (mapDate) {
      let that = this
      var myChart = this.$echarts.init(document.getElementById('map'))
      myChart.hideLoading()
      myChart.on('click', function (params) {
        if (params.seriesType === 'scatter' && params.data.type == 1) {
          vehiclePositionInfo({ id: params.data.id }).then(res => {
            that.vehGps = res
          }).catch(error => {
            that.$message.error(error.message)
          })
          getWayForVehicle({ vehicleId: params.data.id }).then(res => {
            that.vehGps.wayNo = res.wayNo
            that.vehGps.productTypeName = res.productTypeName
            that.vehGps.lineName = res.lineName
          }).catch(error => {
            that.$message.error(error.message)
          })
          that.xingshiFlag = true
        }
      })
      // 配置项
      var option = {
        geo: [
          {
            map: 'map',
            roam: true,
            aspectScale: 1,
            zoom: 1.3,
            silent: true,
            layoutCenter: ['50%', '50%'],
            layoutSize: '180%',
            show: true,
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                areaColor: {
                  type: 'linear',
                  x: 600,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0,33,153,1.000)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(48,126,255,1.000)' // 50% 处的颜色
                    }
                  ],
                  global: true // 缺省为 false
                },
                borderColor: '#017bc9',
                borderWidth: 2
              },
              emphasis: {
                show: false,
                color: '#fff',
                areaColor: 'rgba(0,254,233,1)'
              }
            }
            // map: 'china', // 表示中国地图
            // roam: true, // 是否开启鼠标缩放和平移漫游
            // zoom: 1.5, // 当前视角的缩放比例（地图的放大比例）
            // // center: [118.91, 39.43],
            // scaleLimit: { // 滚轮缩放的极限控制
            //   min: 1
            // },
            // label: {
            //   show: true,
            //   color: '#03faec'
            // },
            // itemStyle: {
            // // 地图区域的多边形 图形样式。
            //   borderColor: 'rgba(0, 0, 0, 0.2)',
            //   normal: {
            //     areaColor: '#01145D', // 区域背景色 地图
            //     borderColor: '#03DBD9' // 每个区域的边框色
            //   },
            //   emphasis: {
            //     areaColor: '#02229b' // 区域背景色 点击后颜色
            //   }
            // },
            // emphasis: {
            //   label: {
            //     color: '#00FFFF'
            //   }
            // }

          }

        ],
        tooltip: {
          formatter: (params) => {
            let str = ''
            if (params.data.businessType == 5) {
              str = ` <div style="margin-bottom: 12px">
                            <span style="color: #fff;">加氢单价：</span>
                            <span>${params.data.unitPrice}元/千克</span>
                          </div>`
            } else if (params.data.businessType == 3) {
              str = ` <div style="margin-bottom: 12px">
                            <span style="color: #fff;">充电单价:</span>
                            <span>${params.data.unitPrice}元/度</span>
                          </div>`
            }
            let html = ''
            html += `<div style="color: #fff;font-size: 16px;padding: 16px;
                      background: linear-gradient(180deg, rgba(37,108,233,0.44) 0%, rgba(23,80,169,0.1) 22%, rgba(20,64,137,0) 46%, rgba(16,51,111,0.28) 77%, rgba(30,101,213,0.4) 100%);
                      border-radius: 2px;border: 1px solid;border-image: radial-gradient(circle, rgba(111, 185, 242, 0.86), rgba(0, 0, 0, 0.2)) 1 1;
                      backdrop-filter: blur(10px);">
                        <div>
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;">名称：</span>
                            <span>${params.data.name}</span>
                          </div>
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;">企业地址：</span>
                            <span>${params.data.address}</span>
                          </div>
                          ${str}
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;">联系人：</span>
                            <span>${params.data.contactsUser}</span>
                          </div>
                          <div style="margin-bottom: 12px">
                            <span style="color: #fff;">联系电话：</span>
                            <span>${params.data.contactsMobile}</span>
                          </div>

                        </div>
                      </div>`
            if (params.data.type == 2) {
              return html
            } else {
              return ''
            }
          }
        },
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: function (value, params) {
              return params.data.img
            },
            symbolSize: [40, 40],
            zlevel: 99999,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return params.name
                },
                position: 'bottom',
                color: '#fff',
                fontSize: '11'
              },
              emphasis: {
                show: false,
                color: '#00d5e9'
              }
            },
            data: mapDate
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 99999,
            symbol: function (value, params) {
              return params.data.img
            },
            symbolSize: [20, 20],
            data: this.carList
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: function (value, params) {
              return params.data.img
            },
            symbolSize: [40, 40],
            zlevel: 99999,
            data: this.dwList
          }

        ]
      }
      // https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=420100_full
      fetch('https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=130200_full').then(response => response.json())
        .then(geoJson => {
          // this.$echarts.registerMap('map', geoJson.features) // 注册自定义的地图
        })
      // this.$echarts.registerMap('map', letingxian) // 注册自定义的地图
      myChart.setOption(option) // 设置配置项
    },
    // 实时运输动态
    ssysdtfn () {
      realTimeWay({}).then(res => {
        this.yunshuList = res
        this.dituFn()
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 人车运量排行
    rcylpaFn () {
      driverOrVehicleTrafficRank({
        type: this.dqIndex2 - 1,
        businessType: this.businessType
      })
        .then(res => {
          this.rencheList = res
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 人车运量排行 切换
    qiehuan2 (n) {
      this.dqIndex2 = n
      this.rcylpaFn()
    }
  },
  computed: {
    optionSetting () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    optionSettingXM () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 20, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    optionSettingLX () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    optionSettingNY () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  }
}
</script>
<style scoped lang='less'>
.cont{
    width: 100%;
    height: 100vh;
    background:  #072648;
    // background-image: url("../../assets/dapingImg/bg.jpg");
    background-size:100% 100% ;
    box-sizing: border-box;
}
.cont .title{
    width: 100%;
    background-image: url("../../../assets/dapingImg/title.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content:space-between;
    box-sizing: border-box;
    padding:0 30px;
    .shijian{
        font-family: DINPro-Bold;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0;
    }
    .riqi{
        font-family: DINPro-Bold;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0;
    }
}
.zhutiBox{
    display: flex;
    justify-content:space-between;
    margin-top: -20px;
}
.box1{
    background-image: url("../../../assets/dapingImg/bj1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
//     border: 1px solid #3ba1ff;
//     box-sizing: border-box;
}
.bian{
    width:28vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bian1{
        width: 100%;
        height: calc(34vh - 34px);
        margin-bottom: 10px;
    }
    .bian2{
        width: 100%;
        height: calc(32vh - 33px); ;
    }
}
.center{
    width: calc(44vw - 20px);
    .center1{
        width: 100%;
        height: calc(68vh - 60px);
        margin-bottom: 10px;
    }
    .center2{
        width: 100%;
        height: calc(32vh - 30px); ;
    }
}
.title1{
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.biaoti{
    height: 100%;
    background-image: url("../../../assets/dapingImg/biaoti.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    font-family: MicrosoftYaHei-Bold;
    font-size: 14px;
    padding: 0 20px;
    line-height:40px;
    letter-spacing: 1px;
    color: #ffffff;
}
.tab{
    height: 50%;
    background-image: url("../../../assets/dapingImg/tab.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    padding: 2px 10px;
    span{
        cursor:pointer;
        padding: 0 10px;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #ffffff;
    }
    .active{
         color: #3ba1ff;
    }
}
//表格滚动
#table {
  width: 100%;
  font-size: 12px;
  overflow: hidden;
  height: 100%;
  .tables {
    width: 100%;
    color: #fff;
    height: 30px;
    line-height: 30px;
    display: flex;
    text-align: center;
    .span_one {
      width: 120px;
      height: 100%;
      background:  linear-gradient(90deg,
        #13326880 0%,
        #1e73f480 46%,
        #13326880 100%);
      margin-right: 1px;
    }
    .span_one:last-child{
         margin-right: 0px;
    }
  }
  .ssysBox .span_one{
    width: 13%;
  }
   .xmrwBox .span_one{
    width: 25%;
  }
}

.seamless-warp2 {
  height: 100%;
  width: 100%;
  overflow: hidden;
  ul {
    margin: 0;
  }
  li {
    display: flex;
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    color: #fff;
    span {
      width: 120px;
      height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

  }
  .ssysBox span{
    width: 13%;
  }
  .xmrwBox span{
    width: 25%;
  }
}

/deep/.el-input__inner{
  font-family: MicrosoftYaHei-Bold;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: transparent;
  border:1px solid #3ba1ff;;
  font-size: 12px;
}
/deep/.el-input__icon{
  line-height: 30px;
}
/deep/.el-select .el-input .el-select__caret{
 color: #3ba1ff;;
}
// 弹框样式
/deep/.el-message-box__header {
  border-bottom: 1px solid #dcdfe6;
}
/deep/.el-message-box__title {
  font-size: 16px;
  color: #333;
}
/deep/.el-dialog__headerbtn {
  top: 12px;
  .el-dialog__close {
    color: #fff;
  }
}
/deep/ .el-dialog__title {
  color: #fff;
}
/deep/ .el-dialog__header {
  padding: 8px 20px;
  background-color: #032781;
  border-radius: 4px 4px 0 0;
}
/deep/ .el-dialog--center {
  border-radius: 4px 4px 0 0;
}
// 表格样式
/deep/  .el-table th {
  background: linear-gradient(90deg,
  #0056ff 0%,
  #1e73f4 46%,
  #0056ff 100%);
  height: 40px;
  color: #fff;
}
/deep/  .el-table {
  color: #333;
}
/deep/  .el-table tr {
  height: 32px;
}
/deep/ .el-table tr:nth-child(even) {
  background-color: #f8fafd;
}
/deep/ .el-table__body tr.hover-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/  .el-table__body tr.current-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/ .el-table .cell {
  text-align: center;
}
.img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
.dituTuli{
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: calc(100% - 28px);
  max-width: 780px;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  z-index: 9;
  pointer-events: none;
  .yunli-row{
    display: flex;
    justify-content: space-around;
    gap: 8px;
    width: 100%;
  }
  .yunli-item{
    width: 25%;
    min-width: 0;
    padding: 4px 6px 5px;
    box-sizing: border-box;
    border: 1px solid rgba(59, 161, 255, 0.48);
    background: linear-gradient(180deg, rgba(7, 38, 72, 0.86) 0%, rgba(10, 67, 123, 0.62) 100%);
    box-shadow: inset 0 0 12px rgba(59, 161, 255, 0.22), 0 0 8px rgba(0, 0, 0, 0.2);
  }
  .lyCunt{
    font-size: 20px;
    line-height: 24px;
    margin: 0;
  }
  .lyTitle{
    font-size: 12px;
    line-height: 18px;
    margin: 0;
  }
  .lyTitle span{
    font-size: 12px;
  }
  .dituTuliItme{
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dttltb{
    display: inline-block;
    width: 1.5vw;
    height:1.5vh;
    border-radius: 20px;
    background-color: #5bd942;
    margin-right: 10px;
  }
  .dttlzt{
    font-family: SourceHanSansCN-Medium;
    font-size: 14px;
    letter-spacing: 1px;
    color: #ffffff;
  }
}
.energy-vehicle-box{
  position: absolute;
  right: 14px;
  bottom: 14px;
  z-index: 9;
  min-width: 112px;
  padding: 8px 10px;
  box-sizing: border-box;
  border: 1px solid rgba(59, 161, 255, 0.48);
  background: linear-gradient(180deg, rgba(7, 38, 72, 0.88) 0%, rgba(10, 67, 123, 0.66) 100%);
  box-shadow: inset 0 0 12px rgba(59, 161, 255, 0.22), 0 0 8px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.energy-vehicle-item{
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  height: 28px;
  color: #fff;
  white-space: nowrap;
}
.energy-vehicle-name{
  width: 34px;
  font-size: 13px;
}
.energy-vehicle-count{
  flex: 1;
  color: #Fdd143;
  font-size: 16px;
  font-weight: bold;
  text-align: right;
}
.energy-vehicle-unit{
  margin-left: 4px;
  font-size: 12px;
}
.team-vehicle-box{
  position: absolute;
  left: 14px;
  bottom: 14px;
  z-index: 9;
  min-width: 150px;
  max-width: 210px;
  padding: 8px 10px;
  box-sizing: border-box;
  border: 1px solid rgba(59, 161, 255, 0.48);
  background: linear-gradient(180deg, rgba(7, 38, 72, 0.88) 0%, rgba(10, 67, 123, 0.66) 100%);
  box-shadow: inset 0 0 12px rgba(59, 161, 255, 0.22), 0 0 8px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.team-vehicle-item{
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  height: 28px;
  color: #fff;
  white-space: nowrap;
}
.team-vehicle-name{
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}
.team-vehicle-count{
  min-width: 28px;
  color: #Fdd143;
  font-size: 16px;
  font-weight: bold;
  text-align: right;
}
.team-vehicle-unit{
  margin-left: 4px;
  font-size: 12px;
}
.boxXS{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0e6eec;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  .cheshubox{
    background-image: url("../../../assets/dapingImg/bj2.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding:3px 15px;
    margin: 2px 0;
      // background-color: rgba(14, 110, 236, 0.3) !important;
  }
/deep/.amap-info-content{
            background:transparent;
            border: none;
            padding: 0;
        }
/deep/.amap-info-outer, /deep/.amap-menu-oute{
   background:transparent;
}
/deep/ .bottom-center .amap-info-sharp{
  border-top: 8px solid #094add;
}
// .amap-info-close
.lyCunt{
  color:#Fdd143;
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0;
}
.lyTitle{
  color:#fff;
  font-size: 16px;
  text-align: center;
  margin-top: 0;
}
.vehicle-distribution-card {
  .title1 > div:not(.biaoti) {
    display: none;
  }
}
</style>
